"use client";

import { Tab, TabGroup, TabList } from "@headlessui/react";

import { cn } from "@/shared/helpers/cn.helper";
import {
  FIND_MY_SCHOOL_MODE_TABS,
  type FindMySchoolSidebarMode,
} from "@/shared/utils/find-my-school-mode-tabs.util";

export type { FindMySchoolSidebarMode } from "@/shared/utils/find-my-school-mode-tabs.util";

export interface FindMySchoolModeTabsProps {
  selectedMode: FindMySchoolSidebarMode;
  mobile?: boolean;
  onChange: (mode: FindMySchoolSidebarMode) => void;
}

export function FindMySchoolModeTabs({
  selectedMode,
  mobile = false,
  onChange,
}: FindMySchoolModeTabsProps) {
  const selectedIndex = Math.max(
    0,
    FIND_MY_SCHOOL_MODE_TABS.findIndex((tab) => tab.key === selectedMode),
  );

  return (
    <div
      className={cn({
        "-mx-3 overflow-x-auto px-3 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden": mobile,
      })}
    >
      <TabGroup
        selectedIndex={selectedIndex}
        onChange={(index) => onChange(FIND_MY_SCHOOL_MODE_TABS[index]?.key ?? "schools")}
      >
        <TabList
          className={cn("flex gap-2", {
            "w-max": mobile,
            "flex-wrap": !mobile,
          })}
        >
          {FIND_MY_SCHOOL_MODE_TABS.map((tab) => (
            <Tab
              key={tab.key}
              className={({ selected }) =>
                cn(
                  "h-9 whitespace-nowrap rounded-full border px-4 text-[14px]/[20px] font-medium transition-colors",
                  "focus:outline-none focus-visible:ring-2 focus-visible:ring-inset",
                  selected
                    ? "border-[#520313] bg-white text-[#520313] focus-visible:ring-[#520313]"
                    : "border-[#E5E4E3] bg-white text-[#4B4849] focus-visible:ring-[#520313]",
                )
              }
            >
              {tab.label}
            </Tab>
          ))}
        </TabList>
      </TabGroup>
    </div>
  );
}
